import { useNavigate } from "react-router-dom";
import Button from "../../components/button";
import Footer from "../../components/footer";

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="h-screen w-screen flex flex-col items-center justify-center">
      <div
        className="flex flex-col items-center justify-center space-y-4"
        style={{
          height: "calc(100% - 32px)",
        }}
      >
        <div className="flex flex-col items-center justify-center">
          <h1 className="text-6xl font-medium">404</h1>
          <p className="text-xl">Oops... page not found</p>
        </div>

        <Button label="Go back to Home" onClick={() => navigate("/")} />
      </div>

      <Footer />
    </div>
  );
}
